// extracted by mini-css-extract-plugin
export default {"aglmd-global-nav__updates__modal":"b3IzCr4scPz3Ya4ehGO3"};